import { FallbackError } from "@core/domain/errors/fallback.error";
import { NotificationAlertDatasource } from "@station/data/datasources/notification-alert.datasource";
import type { NotificationAlertUpdateError } from "@station/domain/errors/alert/notification-alert-update.error";
import type {
    NotificationAlerts,
    NotificationAlertUpdate,
} from "@station/domain/models/notification-alert.model";
import type { NotificationAlertRepository } from "@station/domain/repositories/notification-alert.repository";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class NotificationAlertImplRepository implements NotificationAlertRepository {
    constructor(
        @inject(NotificationAlertDatasource)
        private readonly notificationAlertDatasource: NotificationAlertDatasource,
    ) {}

    getAll(stationId: string): ResultAsync<NotificationAlerts, FallbackError> {
        return this.notificationAlertDatasource.fetchAll(stationId);
    }

    update(
        notificationAlert: NotificationAlertUpdate,
    ): ResultAsync<boolean, NotificationAlertUpdateError> {
        return this.notificationAlertDatasource.update(notificationAlert);
    }

    delete(
        notificationAlertId: string,
    ): ResultAsync<boolean, NotificationAlertUpdateError> {
        return this.notificationAlertDatasource.delete(notificationAlertId);
    }
}
